import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
  Card,
  CardHeader,
  CardText,
  Avatar,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FormsyDate from "../forms/formComponents/FormsyDate";
import formatDate from "../../../utils/formatDate";

class FormReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      taxYear: "",
      releasedNoForm: [],
      rejected: [],
      releasable: [],
      awaitingForm: [],
      message: "",
      styles: {
        formCenterStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
      },
    };

    this.renderTable = this.renderTable.bind(this);
    this.runFormReport = this.runFormReport.bind(this);
    this.submitTaxYear = this.submitTaxYear.bind(this);
    this.resetReport = this.resetReport.bind(this);
    this.exportAllTables = this.exportAllTables.bind(this);
  }

  componentwillRecieveProps(nextProps) {
    if (nextProps.location.query.taxYear) {
      this.setState({ taxYear: nextProps.location.query.taxYear }, () => {
        console.log("have taxYear running report");
        this.runFormReport();
      });
    }
  }

  runFormReport() {
    let url = `/api/reports/formReport?taxYear=${this.state.taxYear}`;
    let options = {
      headers: {
        token: this.props.jwt,
      },
    };
    this.setState({ isLoading: true, message: "Retrieving Report" });
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.status === "complete") {
          this.setState({
            releasedNoForm: json.releasedNoForm,
            rejected: json.rejected,
            releasable: json.releasable,
            awaitingForm: json.awaitingForm,
            isLoading: false,
            message: "",
          });
        } else {
          this.setState({ message: json.status });
          setTimeout(() => this.runFormReport(), 15000);
        }
      });
  }

  submitTaxYear(data) {
    this.setState({ taxYear: data.taxYear }, () => {
      this.runFormReport();
    });
  }

  resetReport() {
    let newState = {
      taxYear: "",
      releasedNoForm: [],
      rejected: [],
      releasable: [],
      awaitingForm: [],
    };

    this.setState(newState);
  }

  notifyFormError(data) {
    alert("Missing Data: check that all fields are filled");
    console.error("Form error:", data);
  }

  renderTable(dataKey) {
    let filter = { type: "TextFilter", delay: 500 };
    let d = new Date();
    let filename = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}-${dataKey}.csv`;
    let tableData = this.state[dataKey].map((report) => {
      return {
        uid: report.client.uid__c,
        name: report.client.name,
        unit: report.ElfStatus.Unit,
        type: report.return.ReturnType,
        elfSummary: report.ElfStatus.SummaryStatus,
      };
    });
    return (
      <BootstrapTable
        ref={dataKey}
        data={tableData}
        pagination
        exportCSV
        csvFileName={filename}
      >
        <TableHeaderColumn
          dataField="uid"
          dataSort
          filter={filter}
          isKey
          width={"100"}
        >
          Client ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataSort filter={filter}>
          Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="unit"
          dataSort
          filter={filter}
          width={"60"}
        >
          Unit
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="type"
          dataSort
          filter={filter}
          width={"140"}
        >
          Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="elfSummary"
          dataSort
          filter={filter}
          width={"110"}
        >
          ELF Status
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }

  exportAllTables(tables) {
    tables.map((ref) => {
      if (ref in this.refs) this.refs[ref].handleExportCSV();
    });
  }

  render() {
    let { formCenterStyle, centerStyle } = this.state.styles;
    if (this.state.isLoading) {
      return (
        <div>
          <center>
            <Loading color={this.props.appbar.color} />
            <h3>{this.state.message}</h3>
          </center>
        </div>
      );
    } else if (this.state.taxYear === "") {
      let years = [];
      let currentYear = new Date().getFullYear();
      for (let i = 1; i <= 8; i++) {
        years.push(currentYear - i);
      }
      return (
        <div>
          <Formsy.Form
            ref="selectTaxYear"
            onValidSubmit={this.submitTaxYear}
            onInvalidSubmit={this.notifyFormError}
          >
            <Subheader>Select Tax Year</Subheader>
            <div style={formCenterStyle}>
              <FormsySelect
                required
                fullWidth
                name="taxYear"
                floatingLabelText="Choose Tax Year"
              >
                {years.map((year) => {
                  return (
                    <MenuItem key={year} value={year} primaryText={year} />
                  );
                })}
              </FormsySelect>
            </div>
            <Divider />
            <div style={centerStyle}>
              <FlatButton
                backgroundColor="#A5D6A7"
                hoverColor="#81C784"
                style={{ marginTop: "2em" }}
                label="Run"
                type="submit"
              />
            </div>
          </Formsy.Form>
        </div>
      );
    } else {
      return (
        <div
          className="container"
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <h3 style={centerStyle}>Tax Year: {this.state.taxYear}</h3>
          <Divider style={centerStyle} />
          <div style={centerStyle}>
            <h3>Rejected ({this.state.rejected.length})</h3>
            {this.renderTable("rejected")}
          </div>
          <div style={centerStyle}>
            <h3>Releasable ({this.state.releasable.length})</h3>
            {this.renderTable("releasable")}
          </div>
          <div style={centerStyle}>
            <h3>Released No Form ({this.state.releasedNoForm.length})</h3>
            {this.renderTable("releasedNoForm")}
          </div>
          <div style={centerStyle}>
            <h3>Awaiting Form ({this.state.awaitingForm.length})</h3>
            {this.renderTable("awaitingForm")}
          </div>
          <Divider style={centerStyle} />
          <div style={centerStyle}>
            <FlatButton
              style={{ marginTop: "2em" }}
              label="Reset"
              onClick={this.resetReport}
            />
            <FlatButton
              style={{ marginTop: "2em" }}
              label="Download All"
              onClick={this.exportAllTables.bind(this, [
                "rejected",
                "releasable",
                "releasedNoForm",
                "awaitingForm",
              ])}
            />
          </div>
        </div>
      );
    }
  }
}

export default FormReport;



// WEBPACK FOOTER //
// ./app/components/reports/FormReport.js